import { AccessCodeContext } from '@rhg/providers/magic-link';
import { useContext } from 'react';

export function useAccessCode() {
    return useContext(AccessCodeContext);
}
